import React from 'react';
import { useMsal } from "@azure/msal-react";
import { makeStyles, Button, LargeTitle, Title1, Subtitle1 } from "@fluentui/react-components";
import { useHandleLogin } from './Components/HandleLogin';
import backgroundImage from './Assets/backgrounds/basecamphero.png';
import logo from './Assets/Logos/logo-white.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrosoft } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import RandomQuote from './Components/RandomQuote';

const useStyles = makeStyles({
  pageWrapper: {
    boxSizing: 'border-box',
    padding: '8px',
    backgroundColor: '#ECECEC',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    position: 'relative', // Allows absolutely positioned children (shade, logo)
  },
  shade: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    zIndex: 1, // Behind the card and logo
  },
  // Move the logo outside pageWrapperInner so it can float top-right
  logoWrapper: {
    position: 'absolute',
    top: '30px',
    left: '30px',
    zIndex: 3, // Above the shade and card
    width: '150px', // Adjust as needed
    height: 'auto',
  },
  logoImage: {
    width: 'auto', // adjust as needed
    height: '60px',
  },
  loginCard: {
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    borderRadius: '12px',
    padding: '50px',
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    margin: '0 auto',
    width: '100%',
    maxWidth: '350px',
    zIndex: 2,
    position: 'relative',
    boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.2)',
  },
  heading: {
    textAlign: 'center',
  },
  link: {
    textAlign: 'center',
    color: 'inherit',
    fontWeight: '900'
  },
});

const LandingPage = () => {
  const { instance } = useMsal();
  const styles = useStyles();
  const { handleLogin } = useHandleLogin();

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.shade}></div>
      {/* Logo is now a sibling of pageWrapperInner and absolutely positioned */}
      <div className={styles.logoWrapper}>
          <img className={styles.logoImage} src={logo} alt="Basecamp Logo" />
        </div>
        <div className={styles.loginCard}>
          <LargeTitle className={styles.heading}>Welcome to Rimo3!</LargeTitle>
          <RandomQuote />
          <Subtitle1 className={styles.heading}>Let's go!</Subtitle1>
          <Button
            size="large"
            appearance="primary"
            icon={<FontAwesomeIcon size='sm' icon={faMicrosoft} />}
            onClick={handleLogin}
          >
            Sign in with Microsoft
          </Button>
          <Link to="/register" className={styles.link}>Don't have an account? Register Here</Link>
        </div>
    </div>
  );
};

export default LandingPage;
